import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo,getWarehouseId,setWarehouseId,removeWarehouseId,getSuperAdminFlag,setSuperAdminFlag,removeSuperAdminFlag } from '@/utils/cookies'
import store from '@/store'
import { passwordLogin, codeLogin, ddLogin, loginOut } from '@/api/login'

export interface UserInfo {
  username: string
  adminId: string
}

export interface UserResponse {
  token: string
  username: string
  adminId: string
  superAdminFlag: string
  warehouses:any
}

export interface IUserState {
  token: string
  userInfo: UserInfo
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public superAdminFlag = getSuperAdminFlag()||'false';
  public warehouse_id = getWarehouseId()||[]
  public userInfo: UserInfo = getUserInfo() || {
    username: '',
    adminId: ''
  }

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
  }

  @Mutation
  private SET_SUPERADMIN_FLAG(superAdminFlag: string) {
    this.superAdminFlag = superAdminFlag
  }

  @Mutation
  private SET_WAREHOUSE_ID(warehouse_id: any) {
    this.warehouse_id = warehouse_id
  }

  @Mutation
  private SET_USER_INFO(userInfo: UserInfo) {
    this.userInfo = userInfo
  }

  // 密码登录
  @Action
  public async PasswordLogin(params: { phone: string, password: string, uuid?: string }) {
    const { content } = await passwordLogin<UserResponse>(params)
    const { token, username, adminId,superAdminFlag,warehouses} = content  
    setToken(token)
    this.SET_TOKEN(token)
    setUserInfo({ username, adminId })
    this.SET_USER_INFO({ username, adminId })
    setSuperAdminFlag(superAdminFlag+'');
    this.SET_SUPERADMIN_FLAG(superAdminFlag)
    setWarehouseId(warehouses)
    this.SET_WAREHOUSE_ID(warehouses)
  }

  // 验证码登录
  @Action
  public async CodeLogin(params: { phone: string, code: string }) {
    const { phone, code } = params
    const { content } = await codeLogin<UserResponse>({ phone, messageCode: code })
    const { token, username, adminId,superAdminFlag,warehouses } = content
    setToken(token)
    this.SET_TOKEN(token)
    setUserInfo({ username, adminId })
    this.SET_USER_INFO({ username, adminId })
    setSuperAdminFlag(superAdminFlag+'');
    this.SET_SUPERADMIN_FLAG(superAdminFlag)
    setWarehouseId(warehouses)
    this.SET_WAREHOUSE_ID(warehouses)
  }

  // 钉钉登录
  @Action
  public async DDLogin(authCode: string) {
    const { content } = await ddLogin<UserResponse>({ auth_code: authCode })
    const { token, username, adminId,superAdminFlag,warehouses } = content
    setToken(token)
    this.SET_TOKEN(token)
    setUserInfo({ username, adminId })
    this.SET_USER_INFO({ username, adminId })
    setSuperAdminFlag(superAdminFlag+'');
    this.SET_SUPERADMIN_FLAG(superAdminFlag)
    setWarehouseId(warehouses)
    this.SET_WAREHOUSE_ID(warehouses)
  }

  @Action
  public ResetToken() {
    removeToken()
    this.SET_TOKEN('')
  }

  @Action
  public async LogOut() {
    await loginOut(this.token)
    removeToken()
    this.SET_TOKEN('')
    removeUserInfo()
    this.SET_USER_INFO({ username: '', adminId: '' })
    removeSuperAdminFlag();
    this.SET_SUPERADMIN_FLAG('false')
    removeWarehouseId();
    this.SET_WAREHOUSE_ID([])
  }
}

export const UserModule = getModule(User)
